document.addEventListener("DOMContentLoaded", function () {

  // --- FAQ アコーディオン ---
  const initFAQAccordion = () => {
    // 初期状態
    $(".p-faq__section:first-of-type .p-faq__item:nth-of-type(2) .p-faq__answer").show();
    $(".p-faq__section:first-of-type .p-faq__item:nth-of-type(2) .p-faq__question").addClass("open");

    // クリックイベント
    $('.p-faq__question').on('click', function () {
      $(this).toggleClass('open');
      $(this).next('.p-faq__answer').slideToggle();
    });
  };

  // --- アコーディオン共通処理 ---
  const initAccordion = () => {
    const handleAccordionToggle = (selector, areaSelector, additionalStyles = {}) => {
      $(selector).on('click', function () {
        $(this).toggleClass('open');
        const area = $(this).next(areaSelector);
        area.slideToggle();
        area.css(additionalStyles);
        area.toggleClass('open');
      });
    };

    // 共通のアコーディオン処理
    handleAccordionToggle('.js-accordion', '.js-accordion-area');
    handleAccordionToggle('.js-accordion-flex', '.js-accordion-area-flex', { display: 'flex' });

    // スマホ用アコーディオン処理
    const mediaQuery = window.matchMedia('(max-width: 768px)');
    const toggleShopAccordion = () => {
      if (mediaQuery.matches) {
        handleAccordionToggle('.js-shop-accordion', '.js-shop-accordion-area', { display: 'block' });
        handleAccordionToggle('.js-footer-accordion', '.js-footer-accordion-area', { display: 'block' });

      } else {
        // イベントを解除する（必要ならアコーディオンを閉じる）
        $('.js-shop-accordion').off('click').removeClass('open');
        $('.js-shop-accordion-area').slideDown().removeClass('open');

        $('.js-footer-accordion').off('click').removeClass('open');
        $('.js-footer-accordion-area').slideDown().removeClass('open');
      }
    };

    // 初回チェックとリサイズ時のイベント
    toggleShopAccordion();
    mediaQuery.addEventListener('change', toggleShopAccordion);
  };

  // --- スムーススクロール ---
  const initSmoothScroll = () => {
    $('a[href^="#"]').on('click', function (event) {
      const target = $($(this).attr('href'));
      const headerHeight = $('.header').outerHeight();

      if (target.length) {
        event.preventDefault();
        $('html, body').animate({
          scrollTop: target.offset().top - headerHeight,
        }, 500);
      }
    });

    const hash = window.location.hash;
    if (hash) {
      const target = $(hash);
      const headerHeight = $('.header').outerHeight();

      if (target.length) {
        setTimeout(() => {
          $('html, body').animate({
            scrollTop: target.offset().top - headerHeight,
          }, 500);
        }, 100);
      }
    }
  };

  // --- スティッキー要素の可視性制御 ---
  const initStickyElement = () => {
    const target = document.querySelector(".js-sticky-relation-product");
    if (!target) return;

    const footer = document.querySelector(".footer");

    document.addEventListener("scroll", function () {
      if (window.scrollY >= 500) {
        target.classList.add("is-visible");
      } else {
        target.classList.remove("is-visible");
      }

      if (target.getBoundingClientRect().bottom >= footer.getBoundingClientRect().top) {
        target.classList.remove("is-visible");
      }
    });
  };

  const initStickyElement2 = () => {
    const target = document.querySelector(".js-product-fixed-btn");
    if (!target) return;

    const footer = document.querySelector(".footer");

    document.addEventListener("scroll", function () {
      if (window.scrollY >= 500) {
        target.classList.add("is-visible");
      } else {
        target.classList.remove("is-visible");
      }

      if (target.getBoundingClientRect().bottom >= footer.getBoundingClientRect().top) {
        target.classList.remove("is-visible");
      }
    });
  };

  // --- Intersection Observer ---
  const initIntersectionObserver = () => {
    const container = document.querySelector('.p-category__recommend-list');
    const items = document.querySelectorAll('.p-category__recommend-list li');
    if (!container || items.length === 0) return;

    const observerOptions = {
      root: container,
      rootMargin: '0px',
      threshold: 0.8,
    };

    const observerCallback = (entries) => {
      entries.forEach((entry) => {
        entry.target.style.opacity = entry.isIntersecting ? 1 : 0.4;
      });
    };

    const observer = new IntersectionObserver(observerCallback, observerOptions);
    items.forEach(item => observer.observe(item));
  };

  // --- 住所検索機能 ---
  const initZipCode = () => {
    $('#zip-button').on('click', () => AjaxZip3.zip2addr('zipcode1', '', 'address1', 'address1'));
  };

  // --- ヘッダー関連 ---
  const initHeader = () => {
    const headerNav = document.querySelector(".js-header-nav");
    const headerNavOpen = document.querySelector(".js-header-nav-open");

    $('.js-header-search-btn').on('click', () => {
      $('.js-header-search').addClass("active");
      $('body').addClass("no-scroll");
    });
    $('.js-header-search-close').on('click', () => {
      $('.js-header-search').removeClass("active");
      $('body').removeClass("no-scroll");
    });

    $(headerNavOpen).on('click', () => {
      $(headerNav).toggleClass("active");
      $(headerNavOpen).toggleClass("active");
      $('body').toggleClass("no-scroll");
    });

    $('.header a').on('click', () => {
      $(headerNav).removeClass("active");
      $(headerNavOpen).removeClass("active");
      $('body').removeClass("no-scroll");
    });

    const mediaQuery = window.matchMedia('(max-width: 768px)');
    function checkWindow(windowSize) {
      if (windowSize.matches) {
        const header = document.querySelector('.header');
        const headerHeight = header.offsetHeight;
        headerNav.style.paddingTop = `${headerHeight}px`;
      } else {
        headerNav.style.paddingTop = "0";
      }
    }
    checkWindow(mediaQuery);
    mediaQuery.addEventListener('change', checkWindow);
    window.addEventListener('resize', checkWindow);
  };

  // --- 検索関連 ---
  const initSearch = () => {

    $('.js-search-more').on('click', function () {
      const hidden_target = $(".js-search-more-targets li.hidden");
      $('.js-search-more').addClass("hidden");
      $(hidden_target).removeClass("hidden");
    });

    $('.js-header-more').on('click', function () {
      const hidden_target = $(".js-header-more-targets li.hidden");
      $('.js-header-more').addClass("hidden");
      $(hidden_target).removeClass("hidden");
    });

    $('#reset-button').on('click', () => $('#search-form')[0].reset());
  };

  // --- レスポンシブヘッダー ---
  const adjustHeaderPadding = () => {
    const header = document.querySelector('.header');
    const main = document.querySelector('main');
    main.style.paddingTop = `${header.offsetHeight}px`;
  };

  const initScrollBar = () => {
    const scrollBar_target = document.querySelector('.c-anchor-linksContainer');
    const scrollBar_target2 = document.querySelector('.header__keyword');

    if (scrollBar_target) {
      new SimpleBar(scrollBar_target, {
        autoHide: false
      })
    }

    if (scrollBar_target2) {
      new SimpleBar(scrollBar_target2, {
        autoHide: false
      });
      adjustHeaderPadding();
    }
  };

  // --- 全機能初期化 ---
  initFAQAccordion();
  initAccordion();
  initSmoothScroll();
  initStickyElement();
  initStickyElement2();
  initIntersectionObserver();
  initHeader();
  initZipCode();
  initSearch();
  window.addEventListener('resize', adjustHeaderPadding);
  adjustHeaderPadding();
  initScrollBar();
});

